import { View, ViewStyle } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';
import { useStore } from 'src/contexts/StoreContext';
import { bottomSheetTestID } from 'src/helpers/testIDs.helper';
import { neutrals } from 'src/theme/colors';
import { CircularButton } from '../buttons/circular-button/CircularButton';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../buttons/circular-button/CircularButton.constants';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { ICON_NAMES } from '../icon/icon.helper';
import { useCallback } from 'react';
import { AuthView } from '../auth-view/AuthView';
import { AuthType } from '../auth-view/LazyAuthView.types';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';

export const BottomSheetLogin = ({ bsStyle }: { bsStyle: ViewStyle }) => {
  const {
    i18n,
    bottomSheet: { closeBottomSheet, bottomSheetData },
  } = useStore();

  const afterCompletedAuthentication = useCallback(() => {
    closeBottomSheet();
  }, []);

  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={{ paddingHorizontal: 16, paddingBottom: 30 }}>
        <View style={{ position: 'absolute', top: 0, right: 16, zIndex: 2 }}>
          <CircularButton
            onPress={async () => closeBottomSheet()}
            accessible={true}
            accessibilityLabel={i18n.t('actions:close_x', { x: '' })}
            accessibilityRole="button"
            iconName={ICON_NAMES.Close}
            iconStyle={{ color: neutrals.neutralGrays.ash }}
            size={CIRCULAR_BUTTON_SIZES.SMALL}
            type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
            testID={bottomSheetTestID(TestIDs.CLOSE)}
            focusId={bottomSheetTestID(TestIDs.CLOSE)}
            focusOrder={0}
            focusGroup={FocusGroups.BOTTOM_SHEET}
          />
        </View>
        <AuthView
          type={AuthType.AUTH}
          afterCompletedAuthentication={afterCompletedAuthentication}
          startingStep={bottomSheetData?.startingStep}
        />
      </View>
    </BottomSheetScrollView>
  );
};
